import type { LaserPattern } from "./LaserPattern";
import type { ChargeFireContext } from "../../charges/Charge";

/**
 * Single straight beam in the current direction.
 */
export class SingleBeamPattern implements LaserPattern {
  fire(ctx: ChargeFireContext): void {
    ctx.shootLaser?.(ctx.direction);
  }
}

export const singleBeamPattern = new SingleBeamPattern();
